export function styleToNumber(style: string | null | undefined, fallback = '0'): number {
    return parseInt(
        style && style.length > 0 ?
            style :
            fallback
    );
}